import * as React from 'react'
import { useUtilities } from '../../../../context/reports/utilities'
import { getConsumption } from '../../../../context/reports/utilities/utils'
import {
  getRankedYearsConfig,
  getRankedSitesConfig,
  getSingleSiteConfig
} from '../utils'
import { ReadingType } from '../../../../context/reports/utilities/types'

/**
 * Retrieve charts configurations for utilities
 * @param filterBy
 */
export const useChart = (filterBy: string[] = []) => {
  const [state] = useUtilities()
  const {
    metrics,
    metricsType,
    sortingDirection
  } = state

  const data = React.useMemo(() => {
    return getConsumption(metrics, metricsType, ReadingType.All, filterBy)
  }, [metrics, metricsType, filterBy])

  const rankedYears = getRankedYearsConfig(data)
  const rankedSites = getRankedSitesConfig(data, metricsType, sortingDirection.rankedSites, sortingDirection.rankedYears)
  const singleSite = getSingleSiteConfig(data, metricsType, sortingDirection.rankedYears)

  return {
    rankedSites,
    rankedYears,
    singleSite
  }
}
